export default __webpack_public_path__ + "static/media/J.93d01723.svg";